import request from '../util/request'

/**
 * 获取 AI 需求评估
 */
export function getAiData () {
  return request({
    url: '/api/getAiData',
    method: 'GET'
  })
}

/**
 * 获取物流金融
 */
export function getLogisticsFinance () {
  return request({
    url: '/api/getLogisticsFinance',
    method: 'GET'
  })
}

/**
 * 获取授信排行榜
 */
export function getCreditRanking () {
  return request({
    url: '/api/getCreditRanking',
    method: 'GET'
  })
}

/**
 * 获取物流金融实时订单详情
 */
export function getRealTimeOrder () {
  return request({
    url: '/api/getRealTimeOrder',
    method: 'GET'
  })
}
